import { PlaceholderAlbumArtwork } from '@audio-network/componentlibrary'
import Image from 'next/image'

import { ALBUM_ARTWORK_S } from '@/constants/sizing'
import optimizeContentfulImage from '@/utils/contentful/optimizeContentfulImage'

import styles from './TrackArtwork.module.css'
import { TrackArtworkProps } from './TrackArtwork.types'

const getArtworkImageUrl = (track: Track | SoundEffect): string | null => {
	if ('album' in track && track.album?.artworkImageUrl) {
		return (
			optimizeContentfulImage(track.album.artworkImageUrl, {
				width: ALBUM_ARTWORK_S,
				height: ALBUM_ARTWORK_S,
			}) ?? track.album.artworkImageUrl
		)
	}

	if ('artworkUrl' in track && track.artworkUrl) {
		return track.artworkUrl
	}

	return null
}

const TrackArtwork = ({ track }: TrackArtworkProps): JSX.Element => {
	const artworkImageUrl = getArtworkImageUrl(track)

	return (
		<div className={styles.artwork}>
			{artworkImageUrl && (
				<Image
					src={artworkImageUrl}
					alt={track.title}
					width={ALBUM_ARTWORK_S}
					height={ALBUM_ARTWORK_S}
					className={styles.image}
				/>
			)}
			{!artworkImageUrl && (
				<PlaceholderAlbumArtwork data-testid="placeholder-album-artwork" />
			)}
		</div>
	)
}

export default TrackArtwork
